import { AI_API_HOST } from '../utils/api-hosts';

export default {
  ai: {
    url: '',
    baseURL: AI_API_HOST,
    methods: {
      stream: req => ({
        url: `/agents/${req.agent_name}/${req.session_uuid}/chat`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        data: req.body,
        method: 'POST',
        toast: false,
        signal: req.signal,
        responseType: 'stream',
        adapter: 'fetch',
      }),
      get_sessions: req => ({
        url: `/agents/${req.agent_name}/sessions`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
      }),
      get_session: req => ({
        url: `/agents/${req.agent_name}/sessions/${req.session_uuid}`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
      }),
      get_artifact: req => ({
        url: `/agents/${req.agent_name}/artifacts/${req.artifact_id}`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
      }),
      get_latest_artifact_data: req => ({
        url: `/agents/${req.agent_name}/widget_data/${req.artifact_id}`,
        ...(req.query && { params: req.query }),
        ...(req.headers && { headers: req.headers }),
        method: 'GET',
        toast: false,
      }),
    },
  },
};
